import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    teamPendingApproval: {
        requesting: false,
        error: null,
        success: false,
        data: []
    },
    teamUpcomingBirthday: {
        requesting: false,
        error: null,
        success: false,
        data: []
    },
    teamLeaveApprovedList: {
        requesting: false,
        error: null,
        success: false,
        data: []
    },
    employeeAttendanceRecord: {
        requesting: false,
        error: null,
        success: false,
        data: {
            overview: [],
            totals: { 
                total_present_days: 0,
                total_absent_days: 0,
                total_late_days: 0,
                total_on_leave: 0,
            }
        },
    },
    dailyAttendanceRecord: {
        requesting: false,
        error: null,
        success: false,
        data: {
            overview: [],
            totals: { 
                total_present_days: 0,
                total_absent_days: 0,
                total_late_days: 0,
                total_on_leave: 0,
            }
        },
    },
    weeklyAttendanceRecord: {
        requesting: false,
        error: null,
        success: false,
        data: {
            overview: [],
            totals: { 
                total_present_days: 0,
                total_absent_days: 0,
                total_late_days: 0,
                total_on_leave: 0,
            }
        },
    },
    teamHolidayList: {
        requesting: false,
        error: null,
        success: false,
        data: [],
        filters: {},
    },
    teamOverviewStat: {
        requesting: false,
        error: null,
        success: false,
        data: []
    },
};

export const overviewSlice = createSlice({
  name: 'overview',
  initialState,
  reducers: {
    
    getPendingApproval: (state, action) => {
        state.teamPendingApproval.requesting = true;
        state.teamPendingApproval.error = null;
        state.teamPendingApproval.data = [];
        state.teamPendingApproval.success = false;
        state.teamPendingApproval.filters = action.payload;
    },
    getPendingApprovalSuccess: (state, action) => {
        state.teamPendingApproval.requesting = false;
        state.teamPendingApproval.data = action.payload;
        state.teamPendingApproval.success = true; 
    },
    getPendingApprovalFail: (state, action) => {        
        state.teamPendingApproval.requesting = false;
        state.teamPendingApproval.error = action.payload;
    },

    getUpcomingBirthday: (state, action) => {
        state.teamUpcomingBirthday.requesting = true;
        state.teamUpcomingBirthday.error = null;
        state.teamUpcomingBirthday.data = [];
        state.teamUpcomingBirthday.success = false;
        state.teamUpcomingBirthday.filters = action.payload;
    },
    getUpcomingBirthdaySuccess: (state, action) => {
        state.teamUpcomingBirthday.requesting = false;
        state.teamUpcomingBirthday.data = action.payload;
        state.teamUpcomingBirthday.success = true; 
    },
    getUpcomingBirthdayFail: (state, action) => {        
        state.teamUpcomingBirthday.requesting = false;
        state.teamUpcomingBirthday.error = action.payload;
    },

    getLeaveApprovedList: (state, action) => {
        state.teamLeaveApprovedList.requesting = true;
        state.teamLeaveApprovedList.error = null;
        state.teamLeaveApprovedList.data = [];
        state.teamLeaveApprovedList.success = false;
        state.teamLeaveApprovedList.filters = action.payload;
    },
    getLeaveApprovedListSuccess: (state, action) => {
        state.teamLeaveApprovedList.requesting = false;
        state.teamLeaveApprovedList.data = action.payload;
        state.teamLeaveApprovedList.success = true; 
    },
    getLeaveApprovedListFail: (state, action) => {        
        state.teamLeaveApprovedList.requesting = false;
        state.teamLeaveApprovedList.error = action.payload;
    },
    getAttendanceSummary: (state) => {
        state.employeeAttendanceRecord.requesting = true;
        state.employeeAttendanceRecord.error = null;
        state.employeeAttendanceRecord.data = null;
    },
    getAttendanceSummarySuccess: (state, action) => {
        state.employeeAttendanceRecord.requesting = false;
        state.employeeAttendanceRecord.data = action.payload;
        state.employeeAttendanceRecord.success = true;
    },
    getAttendanceSummaryFail: (state, action) => {
        state.employeeAttendanceRecord.requesting = false;
        state.employeeAttendanceRecord.error = action.payload;
    },
    getAttendanceToday: (state) => {
        state.dailyAttendanceRecord.requesting = true;
        state.dailyAttendanceRecord.error = null;
        state.dailyAttendanceRecord.data = null;
    },
    getAttendanceTodaySuccess: (state, action) => {
        state.dailyAttendanceRecord.requesting = false;
        state.dailyAttendanceRecord.data = action.payload;
        state.dailyAttendanceRecord.success = true;
    },
    getAttendanceTodayFail: (state, action) => {
        state.weeklyAttendanceRecord.requesting = false;
        state.dailyAttendanceRecord.error = action.payload;
    },
    getWeeklyAttendance: (state) => {
        state.weeklyAttendanceRecord.requesting = true;
        state.weeklyAttendanceRecord.error = null;
        state.weeklyAttendanceRecord.data = null;
    },
    getWeeklyAttendanceSuccess: (state, action) => {
        state.weeklyAttendanceRecord.requesting = false;
        state.weeklyAttendanceRecord.data = action.payload;
        state.weeklyAttendanceRecord.success = true;
    },
    getWeeklyAttendanceFail: (state, action) => {
        state.weeklyAttendanceRecord.requesting = false;
        state.weeklyAttendanceRecord.error = action.payload;
    },
    getHolidayList: (state, action) => {
        state.teamHolidayList.requesting = true;
        state.teamHolidayList.error = null;
        state.teamHolidayList.data = [];
        state.teamHolidayList.success = false;
        state.teamHolidayList.filters = action.payload;
    },
    getHolidayListSuccess: (state, action) => {
        state.teamHolidayList.requesting = false;
        state.teamHolidayList.data = action.payload;
        state.teamHolidayList.success = true; 
    },
    getHolidayListFail: (state, action) => {        
        state.teamHolidayList.requesting = false;
        state.teamHolidayList.error = action.payload;
    },
    getTeamOverviewStat: (state, action) => {
        state.teamOverviewStat.requesting = true;
        state.teamOverviewStat.error = null;
        state.teamOverviewStat.data = {};
        state.teamOverviewStat.success = false;
        state.teamOverviewStat.filters = action.payload;
    },
    getTeamOverviewStatSuccess: (state, action) => {
        state.teamOverviewStat.requesting = false;
        state.teamOverviewStat.data = action.payload;
        state.teamOverviewStat.success = true; 
    },
    getTeamOverviewStatFail: (state, action) => {        
        state.leavteamOverviewStateStat.requesting = false;
        state.teamOverviewStat.error = action.payload;
    },
  },
})

export const { 
    getPendingApproval, getPendingApprovalSuccess, getPendingApprovalFail,
    getUpcomingBirthday, getUpcomingBirthdaySuccess, getUpcomingBirthdayFail,
    getLeaveApprovedList, getLeaveApprovedListSuccess, getLeaveApprovedListFail,
    getAttendanceSummary, getAttendanceSummarySuccess, 
    getAttendanceSummaryFail,
    getAttendanceToday, getAttendanceTodaySuccess,
    getAttendanceTodayFail,
    getWeeklyAttendance, getWeeklyAttendanceSuccess,
    getWeeklyAttendanceFail,
    getHolidayList, getHolidayListSuccess, getHolidayListFail,
    getTeamOverviewStat, getTeamOverviewStatSuccess, getTeamOverviewStatFail,
} = overviewSlice.actions
export default overviewSlice.reducer